<template>
  <div class="loginMain">
    <el-dialog
      :visible.sync="showLogin"
      :show-close="true"
      :append-to-body="true"
      width="380px"
      lock-scroll
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="true"
      @close="closeLogin"
    >
      <div class="dialogmain">
        <!-- <p class="headtab">
          <span :class="tab == 1 ? 'active' : ''" @click="changeTab(1)">账号登录</span>
        </p> -->
        <p class="headtab">
          <span :class="tab == 1 ? 'active' : ''" @click="changeTab(1)"
            >账号登录</span
          >
          <span :class="tab == 2 ? 'active' : ''" @click="changeTab(2)"
            >扫码登录</span
          >
        </p>
        <div class="userlogin" v-show="tab == 1">
          <el-form :model="loginForm" status-icon :rules="rules" ref="ruleForm">
            <el-form-item prop="Phone">
              <el-input
                type="text"
                v-model="loginForm.Phone"
                placeholder="请输入手机号"
                maxlength="11">
              </el-input>
            </el-form-item>
            <el-form-item prop="Code" class="getcode">
              <el-input
                style="width: 60%"
                type="text"
                v-model="loginForm.Code"
                @keyup.enter.native="submitForm('ruleForm')"
                placeholder="请输入验证码"
              ></el-input>
              <el-button
                class="codeBtn"
                type="primary"
                :disabled="!canSend"
                @click="sendCode"
                >{{ codeNum ? codeNum : "获取验证码" }}</el-button
              >
              <!-- <div class="codeBtn"></div> -->
            </el-form-item>
            <el-form-item class="loginBtnForm">
              <el-button
                type="primary"
                round
                @click="submitForm('ruleForm')"
                class="loginBtn"
                :loading="loading"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
          <div class="codemsg">没有收到验证码? 请联系您的课程顾问</div>
        </div>
        <div class="wechatLogin" v-show="tab == 2">
          <div class="wxCode">
            <div class="qrCode">
              <img v-if="loginQrCode.Url" alt="微信二维码" :src="loginQrCode.Url" />
              <div @click="getLoginQrCode" v-if="showRefresh" class="refresh"><i class="icon el-icon-refresh-right"></i></div>
            </div>
            <p>微信扫码登录</p>
              <!-- <wxlogin
                  class="scodeShow"
                  :href="hrefs"
                  :appid="appid"
                  :scope="scope"
                  id="login_container"
                  :redirect_uri="redirect_uri" ></wxlogin> -->
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import wxlogin from "vue-wxlogin";
export default {
  components: {wxlogin},
  data() {
    return {
      showRefresh: false,
      loginQrCode: {},
      qrCodeTimer: null,
      timerNum: 0,
      tab: 1,
      loading: false,
      loginForm: {
        Phone: '',
      },
      canSend: true,
      codeNum: false,
      appid: "wx235aa3092a853545",//二维码登录appid
      scope: "snsapi_login",
      // redirect_uri: encodeURIComponent(window.location.origin + "/#/layout/person"), //重定向地址，需要进行UrlEncode
      redirect_uri: encodeURIComponent(window.location.href), //重定向地址，需要进行UrlEncode
      hrefs: "data:text/css;base64,LnRpdGxlewogICAgZGlzcGxheTogbm9uZTsKfQouaW1wb3dlckJveCAucXJjb2RlewogICAgbWFyZ2luOiAwOwp9Ci5pbXBvd2VyQm94IC5zdGF0dXMgcHsKICAgIGZvbnQtc2l6ZTogMTZweDsKICAgIGNvbG9yOiAjNzc3Owp9Ci5pbXBvd2VyQm94IC5zdGF0dXN7CiAgICB0ZXh0LWFsaWduOiBjZW50ZXIgIWltcG9ydGFudDsKfQ==",//自定义样式链接，第三方可根据实际需求覆盖默认样式。
      rules: {
        Phone: [
          { required: true, message: "请输入正确的手机号", trigger: "change" },
          {
            max: 11,
            message: "长度在11个字符",
            trigger: "change",
          },
        ],
        Code: [
          { required: true, message: "请输入验证码", trigger: "change" },
          { max: 6, message: "长度为6个字符", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    showLogin: {
      get() {
        this.tab = 1
        // if(this.tab == 2) {
        //   this.getLoginQrCode()
        // }
        return this.$store.state.showLogin;
      },
      set() {},
    },
  },
  methods: {
    closeLogin() {
      this.$store.commit("changeShowLoginState", false);
      this.$store.commit("setDrawerState", false);
      this.clearTimer()
    },
    sendCode() {
      let reg = /^(?:(?:\+|00)86)?1\d{10}$/;
      if(!reg.test(this.loginForm.Phone)) {
        this.$message.error('请输入正确的手机号');
        return;
      }
      this.$post('/Member/v1/sendcode', {
        Phone: this.loginForm.Phone
      }).then(res => {
        if (res.Code == 200) {
          this.$message({
            type: "success",
            message: res.Msg
          });
          this.codeNum = 59;
          this.canSend = false;
          this.codeTimer = setInterval(() => {
            this.codeNum--;
            if (this.codeNum == 0) {
              this.canSend = true;
              clearInterval(this.codeTimer);
              this.codeNum = null;
            }
          }, 1000);
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            this.loading = true;
            // setTimeout(()=>{
            //     this.loading = false;
            // },3000)
            this.codeNum = 0;
            clearInterval(this.codeTimer);
            this.canSend = true;
            this.$store.commit("setDrawerState", false);
            this.login()
        } else {
          return false;
        }
    });
    },
    login() {
      let _this=this;
      this.$post('/Member/v1/login', {
        Phone: this.loginForm.Phone,
        Code: this.loginForm.Code
      }).then(res => {
        this.loading = false;
        if(!res) {
          return false
        }
        if(res.Data.BindType == 1 || res.Data.BindType == 2) {
          // this.closeLogin()
          if (res.Data.BindType == 2) {
            let loginInfo=res.Data;
            this.$store.commit('setLoginInfo', loginInfo)
            sessionStorage.setItem('loginInfo', JSON.stringify(loginInfo));
            this.closeLogin()
            this.$store.commit('openRegister')
          }
          return false;
        }
        if (res.Data.IsReg) {
          let loginInfo=res.Data;
          this.$store.commit('setLoginInfo', loginInfo)
          sessionStorage.setItem('loginInfo', JSON.stringify(loginInfo));
          this.closeLogin()
          this.$store.commit('openRegister')
          return false;
        }
        this.getMobileToken()
        this.closeLogin()
        let loginInfo=res.Data;
        this.$store.commit('setLoginInfo', loginInfo)
        sessionStorage.setItem('loginInfo', JSON.stringify(loginInfo));
        _this.$get('Member/v1/membercenter',{}).then(ress=>{
            if(ress.Code==200){
              let objs=ress.Data;
              _this.$get('Goods/v1/addresslist',{type:0}).then(addres=>{
                if(addres.Code==200){
                  objs.addresNum=addres.Data?addres.Data.length:0;
                  _this.$post('Platform/GetIntegral',{}).then(apx=>{
                    if(apx.Code==200){
                      objs.Jifen=apx.Data;
                    }else{
                      objs.Jifen=0;
                    }
                    _this.$store.commit('setheaderInfo', objs)
                    sessionStorage.setItem('headerInfo',JSON.stringify(objs));
                    window.location.reload();
                  })
                }
              })
              
            }
          })
      })
    },
    getMobileToken() {
      this.$get('Member/v1/mobtoken').then(res => {
        console.log(res)
        this.$store.commit('setMobileToken', res.Data)
        sessionStorage.setItem('mobileToken', res.Data);
      })
    },
    changeTab(tab) {
      this.clearTimer()
      // this.tab = 1;
      // let href = window.location.href
      let href = 'https://yingcaiclient.yingcaiyuanfu.com/layout/index'
      this.tab = tab;
      if(tab==2){
          this.getLoginQrCode()
          // if(href.indexOf("code")!=-1){
          //     this.redirect_uri = encodeURIComponent(href.split("?")[0]);
          //     console.log(href.split("?")[0])
          // }else{
          //     this.redirect_uri = encodeURIComponent(href);
          // }
      }
    },
    getLoginQrCode() {
      this.clearTimer()
      console.log('1')
      this.$get('Member/v1/initqrurl').then(res => {
        this.loginQrCode = res.Data
        this.$store.commit('setLoginQrCode', res.Data)
        this.startTimer()
      })
    },
    qrCodeLogin() {
      this.$get('Member/v1/checkscene', {
        scene: this.loginQrCode.Scene
      }).then(res => {
        if(res){
          if (res.Code == 200) {
            this.clearTimer()
            if(res.Data.BindType==1){ // 绑定手机号
              this.$store.commit('changeShowBindStatus', true)
              this.$store.commit('setUnionId', res.Data.UnionId || '')
            } else if (res.Data.BindType==2) { // 绑定姓名公司名
              this.$store.commit('changeShowRegisterStatus', true)
            } else {
              this.$store.commit('changeShowLoginState', false)
              this.$store.commit('setLoginInfo', res.Data)
              sessionStorage.setItem('loginInfo', JSON.stringify(res.Data));
              this.$store.commit('setHeaderInfo')
              // setTimeout(()=>{
              //   window.location.reload()
              // },200)
            }
          } else if (res.Code == 201) {
            console.log('扫码等待中……')
          }
        }
      })
    },
    clearTimer() {
      clearInterval(this.qrCodeTimer);
      this.timerNum = 0
      this.loginQrCode = {}
    },
    startTimer() {
      let that = this;
      that.qrCodeTimer = setInterval(() => {
        that.timerNum ++
        if (that.showLogin && that.tab == 2) {
          if (that.loginQrCode.ExpireSeconds <= that.timerNum) {
            that.$message({
              type:"warning",
              message: '二维码过期，请重新扫码'
            });
            that.showRefresh = true
            // that.getLoginQrCode()
            that.clearTimer()
          } else {
            that.qrCodeLogin()
          }
        } else {
          that.clearTimer()
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
// .loginMain{
// height: 100%;
.dialogmain {
  position: relative;
  .closeicon {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  .headtab {
    padding: 13px 0 40px;
    text-align: center;
    color: #999;
    font-size: 20px;
    span {
      margin: 0 20px;
      cursor: pointer;
      position: relative;
      padding-bottom: 10px;
      &::after {
        display: block;
        content: " ";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 32px;
        height: 2px;
        background: transparent;
      }
    }
    .active {
      color: #333;
      &::after {
        background: #2075f5;
      }
    }
  }
  .userlogin {
    padding: 0 44px 50px;
    .getcode {
      .el-form-item__content {
        display: flex;
      }
      .codeBtn {
        width: 38%;
        height: 48px;
        background: rgba($color: #2075f5, $alpha: 0.1);
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #2075F5;
      }
    }
    .loginBtnForm {
      text-align: center;
      .loginBtn {
        font-size: 18px;
        padding: 13px 102px;
        border-radius: 25px;
        margin: 28px auto 0;
        background: #2075f5;
      }
    }
    .codemsg {
      padding-top: 40px;
      border-top: 1px solid #efefef;
      font-size: 14px;
      color: #777;
      text-align: center;
      margin-top: 50px;
    }
  }
  .wechatLogin {
    .wxCode {
      // padding-left: 40px;
      text-align: center;
      .qrCode {
        margin: 0 auto;
        width: 300px;
        height: 300px;
        position: relative;
        margin-bottom: 30px;
        .refresh {
          position: absolute;
          width: 300px;
          height: 300px;
          left: 0;
          top: 0;
          background: rgba($color: #000, $alpha: 0.8);
          text-align: center;
          display: flex;
          align-items: center;
          .icon {
            margin: 0 auto;
            color: #fff;
            font-size: 80px;
            line-height: 0;
            font-weight: bold;
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .scodeShow {
        iframe {
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
}
// }
</style>


// WEBPACK FOOTER //
// src/components/login/login.vue